import { render, staticRenderFns } from "./provinceFixPriceTable.vue?vue&type=template&id=d02178d4&scoped=true"
import script from "./provinceFixPriceTable.vue?vue&type=script&lang=js"
export * from "./provinceFixPriceTable.vue?vue&type=script&lang=js"
import style0 from "./provinceFixPriceTable.vue?vue&type=style&index=0&id=d02178d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d02178d4",
  null
  
)

export default component.exports